import Config from "../../app/config/Config";
import BaseSaveModel from "../savegame/BaseSaveModel";
import SaveEvent from "../savegame/SaveEvent";
import PlatformAPIService from "./PlatformAPIService";

export default class MockPlatformAPIService extends PlatformAPIService {

    /**
     * @param {BaseSaveModel} saveModel 
     * @param {Config} config
     * @param {soma.EventDispatcher} dispatcher;
     */
    constructor(saveModel, config, dispatcher) {
        super(saveModel, dispatcher);
        this._config = config;
        this._dispatcher = dispatcher;
    }

    initialize(version) {
        const environment = this._config.getValue(Config.ENVIRONMENT);
        this._api = this._createMockApi(environment);
        this._version = version;

        // Expose service to `window` object so its methods can be called via the Console.
        // NB: this can be useful to trigger the response duration, object and timeout state 
        // via the debug methods
        if (ranj.DEBUG) {
            window.mockApiService = this._api;
        }
    }

    exit() {
        this._dispatcher.dispatch(SaveEvent.CLEAR);
        super.exit();
    }

    _createMockApi(environment) {
        return new MockApi(environment);
    }
}